/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Move wishlist button below add to cart
  document.addEventListener('DOMContentLoaded', function() {
    function moveWishlist() {
      var wishlist = document.querySelector('.Vtl-WishlistButtonWrapper');
      var addToCart = document.querySelector('[id^="ProductSubmitButton-"]');
      
      if (wishlist && addToCart) {
        addToCart.parentNode.insertAdjacentElement('afterend', wishlist);
      }
    }
    
    moveWishlist();
    setTimeout(moveWishlist, 1500);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



